import { render, staticRenderFns } from "./QuickActionsCard.vue?vue&type=template&id=a4c2c2da&scoped=true&"
import script from "./QuickActionsCard.vue?vue&type=script&lang=js&"
export * from "./QuickActionsCard.vue?vue&type=script&lang=js&"
import style0 from "./QuickActionsCard.vue?vue&type=style&index=0&id=a4c2c2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2c2da",
  null
  
)

export default component.exports